<template>
  <div>
    <Header :title="'创建纪念馆'" />
    <!-- 步骤条 -->
    <div class="steps-section">
      <div class="step-item active">1.填写初建馆资料</div>
      <div class="step-next" />
      <div class="step-item">2.选择纪念馆模板</div>
    </div>

    <!-- 纪念馆区 -->
    <ul class="hall-section">
      <li ref="category" class="hall-item" @click="categorySheet">
        <div class="hall-title"><label>纪念馆类别</label></div>
        <div class="hall-selected">{{ hallCategory }}</div>
        <div class="hall-arrow iconfont">&#xe655;</div>
        <transition
          name="fade"
        ><span
          v-show="isCategoryEmpty"
          class="hall-tip bold"
        >*请选择类别</span></transition>
      </li>
      <nut-actionsheet
        :choose-tag-value="hallCategory"
        :is-visible="isVisibleCategory"
        :menu-items="categoryList"
        @choose="chooseCategory"
        @close="categorySheet"
      />
      <li ref="level" class="hall-item" @click="levelSheet">
        <div class="hall-title">纪念馆级别</div>
        <div class="hall-selected">{{ hallLevel }}</div>
        <div class="hall-arrow iconfont">&#xe655;</div>
        <transition
          name="fade"
        ><span
          v-show="isLevelEmpty"
          class="hall-tip bold"
        >*请选择级别</span></transition>
      </li>
      <nut-actionsheet
        ref="levelList"
        :choose-tag-value="hallLevel"
        :is-visible="isVisibleLevel"
        :menu-items="levelList"
        @choose="chooseLevel"
        @close="levelSheet"
      />
    </ul>

    <!-- 主要信息 -->
    <div class="main-section">
      <ul class="main-info">
        <li ref="hallName" class="main-item">
          <div class="main-title">纪念馆名称</div>
          <div class="main-input">
            <input
              v-model="hallName"
              maxlength="15"
              placeholder="请输入名称"
              type="text"
              @blur="checkHallName"
              @focus="deleHallClass"
            >
          </div>

          <transition
            name="fade"
          ><span
            v-show="isHallEmpty"
            class="main-tip bold"
          >*名称不能为空</span></transition>
        </li>
        <li ref="deadName" class="main-item">
          <div class="main-title">逝者姓名</div>
          <div class="main-input">
            <input
              v-model="deadName"
              maxlength="6"
              placeholder="请输入姓名"
              type="text"
              @blur="checkDeadName"
              @focus="deleDeadNameClass"
            >
          </div>

          <transition
            name="fade"
          ><span
            v-show="isDeadNameEmpty"
            class="main-tip bold"
          >*姓名不能为空</span></transition>
        </li>
        <li ref="birthday" class="main-item">
          <div>出生日期</div>
          <div class="main-day" @click="switchPicker('isVisibleBirth')">
            {{ birthDay }}
          </div>
          <nut-datepicker
            :default-value="birthDay"
            :is-visible="isVisibleBirth"
            :start-date="startDate"
            title="请选择出生日期"
            type="date"
            @choose="chooseBirth"
            @close="switchPicker('isVisibleBirth')"
          />
          <transition
            name="fade"
          ><span
            v-show="isBirthdayEmpty"
            class="main-tip bold"
          >*请选择出生日期</span></transition>
        </li>
        <li ref="deathday" class="main-item">
          <div>逝世日期</div>
          <div class="main-day" @click="switchPicker('isVisibleDeath')">
            {{ deathDay }}
          </div>
          <nut-datepicker
            :default-value="endDate"
            :is-visible="isVisibleDeath"
            :start-date="startDate"
            title="请选择逝世日期"
            type="date"
            @choose="chooseDeath"
            @close="switchPicker('isVisibleDeath')"
          />
          <transition
            name="fade"
          ><span
            v-show="isDeathdayEmpty"
            class="main-tip bold"
          >*请选择逝世日期</span></transition>
        </li>
      </ul>
      <div class="main-avatar">
        <div
          :style="{
            backgroundImage: `url(${$resUrl(picture)})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }"
          class="main-ava"
        />
        <van-uploader
          :after-read="afterRead"
          :before-read="beforeRead"
          :max-count="1"
          :max-size="1024 * 1024 * 5"
          :preview-image="true"
          :show-upload="true"
          @oversize="onOversize"
        >
          <span class="iconfont">&#xe7b0;</span>上传图片
        </van-uploader>
        <div class="main-intro">（默认平台相片）</div>
        <transition
          name="fade"
        ><span
          v-show="isAvatarEmpty"
          class="avatar-tip bold"
        >*请上传逝者头像</span></transition>
      </div>
    </div>

    <!-- 关系区域 -->
    <ul class="relationship-section">
      <li ref="emotion" class="relationship-item" @click="emotionSheet">
        <div class="relationship-title"><label>情感关系</label></div>
        <div class="relationship-selected">{{ emotion }}</div>
        <div class="relationship-arrow iconfont">&#xe655;</div>
        <transition
          name="fade"
        ><span
          v-show="isEmotionEmpty"
          class="relationship-tip bold"
        >*请选择情感关系</span></transition>
      </li>
      <nut-actionsheet
        :choose-tag-value="emotion"
        :is-visible="isVisibleEmotion"
        :menu-items="emotionList"
        @choose="chooseEmotion"
        @close="emotionSheet"
      />
      <li ref="memorial" class="relationship-item" @click="memorialSheet">
        <div class="relationship-title"><label>纪念关系</label></div>
        <div class="relationship-selected">{{ memorial }}</div>
        <div class="relationship-arrow iconfont">&#xe655;</div>
        <transition
          name="fade"
        ><span
          v-show="isMemorialEmpty"
          class="relationship-tip bold"
        >*请选择纪念关系</span>
        </transition>
      </li>
      <nut-actionsheet
        :choose-tag-value="memorial"
        :is-visible="isVisibleMemorial"
        :menu-items="memorialList"
        @choose="chooseMemorial"
        @close="memorialSheet"
      />
    </ul>

    <!-- 墓碑祭词 -->
    <ul class="comment-section">
      <li class="comment-header">
        <div class="comment-title">墓碑祭词</div>
        <div class="comment-temp-entry" @click="toCommentTemp">
          选择模板<i class="iconfont">&#xe655;</i>
        </div>
      </li>
      <nut-textbox
        ref="comment"
        v-model="comment"
        :max-num="100"
        :switch-max="true"
        :txt-area-h="130"
        place-text="请输入墓碑祭词..."
        text-bg-color="#efefef"
      />
    </ul>

    <!-- 服务条款 -->
    <div class="service-section">
      <nut-checkbox v-model="checkbox">
        <span>我已阅读并同意</span>
      </nut-checkbox>
      <div class="service-terms" @click="termsOpen">《服务条款协议》</div>
    </div>
    <van-dialog v-model="showDialog" :title="terms.title">
      <div class="service_text" v-html="terms.content" />
    </van-dialog>

    <!-- 下一步 -->
    <div class="next-section">
      <div class="next-default" @click="clickDefault">自动创建纪念馆</div>
      <div class="next-next" @click="clickNext">下一步</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { createHall, getCreateData } from '@/api/Personal/Hall'
import { getSinglepage, uploadImg } from '@/api/Comm'
import Storage from '@/utils/storage'
import { Dialog, Toast, Uploader } from 'vant'
import Header from '@/components/Header/Index'

Vue.use(Uploader)

export default {
  name: 'Index',
  components: {
    Header,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      picture: '/upload/default.jpg',
      avatar: '',

      initData: [],
      levelList: [],
      categoryList: [],
      emotionList: [],
      memorialList: [],

      show: false,
      hallCategory: '请选择',
      hallLevel: '请选择',
      emotion: '请选择',
      memorial: '请选择',
      startDate: '1900-01-01',
      birthDay: '请选择',
      deathDay: '请选择',
      endDate: new Date().toISOString().substr(0, 10),
      hallCategoryId: -1,
      hallLevelId: -1,
      emotionId: -1,
      memorialId: -1,
      inHallModelId: -1,
      outHallModelId: -1,
      isVisibleCategory: false,
      isVisibleLevel: false,
      isVisibleEmotion: false,
      isVisibleMemorial: false,
      isVisibleBirth: false,
      isVisibleDeath: false,

      isCategoryEmpty: false,
      isLevelEmpty: false,
      isDeadNameEmpty: false,
      isHallEmpty: false,
      isBirthdayEmpty: false,
      isDeathdayEmpty: false,
      isAvatarEmpty: false,
      isReligionEmpty: false,
      isNationalityEmpty: false,
      isProfessionEmpty: false,
      isEmotionEmpty: false,
      isMemorialEmpty: false,
      isCommentEmpty: false,

      count: 0,
      checkbox: false,
      hallName: '',
      deadName: '',
      comment: '',
      terms: {},
      showDialog: false
    }
  },
  computed: {
    hallData() {
      return {
        memorialHallCategoryId: this.hallCategoryId,
        memorialHallLevel: this.hallLevelId,
        memorialHallName: this.hallName,
        deadName: this.deadName,
        birthDate: this.birthDay,
        deadDate: this.deathDay,
        emotionId: this.emotionId,
        anniversaryId: this.memorialId,
        tombstoneContent: this.comment,
        picture: this.avatar,
        inHallModelId: this.inHallModelId,
        outHallModelId: this.outHallModelId
      }
    },
    commentLeft() {
      return this.$refs.comment.maxNum - this.$refs.comment.txtNum >= 0
        ? this.$refs.comment.maxNum - this.$refs.comment.txtNum
        : 0
    }
  },
  watch: {
    birthDay(newValue, oldValue) {
      if (newValue > this.deathDay && this.deathDay !== '请选择') {
        this.deathDay = newValue
      }
    },
    deathDay(newValue, oldValue) {
      this.endDate = newValue
      if (newValue < this.birthDay && this.birthDay !== '请选择') {
        this.birthDay = newValue
      }
    },
    comment() {
      this.$refs.comment.$el.childNodes[0].childNodes[2].innerHTML = `你还可以输入<div class='comment-left'>${this.commentLeft}</div>个字`
    }
  },
  created() {
    if (Storage.localGet('newHall') !== null) {
      const localData = Storage.localGet('newHall')
      this.hallCategoryId = localData.memorialHallCategoryId
      this.hallLevelId = localData.memorialHallLevel
      this.hallName = localData.memorialHallName
      this.deadName = localData.deadName
      this.birthDay = localData.birthDate
      this.deathDay = localData.deadDate
      if (localData.picture) {
        this.avatar = localData.picture
        this.picture = this.$resUrl(this.avatar)
      }
      this.emotionId = localData.emotionId
      this.memorialId = localData.anniversaryId
      this.comment = localData.tombstoneContent
    }
    if (Storage.localGet('CommentTempSelectd')) {
      const info = Storage.localGet('CommentTempSelectd')
      this.comment = info.content
    }
    this.getInitData()
    this.getTermsOfService()
  },
  mounted() {
    this.$refs.comment.$el.childNodes[0].childNodes[2].innerHTML = `你还可以输入<div class='comment-left'>${this.commentLeft}</div>个字`
  },
  methods: {
    toCommentTemp() {
      Storage.localSet('newHall', this.hallData)
      this.$router.push('/Personal/Hall/Create/CommentTemp')
    },
    getInitData() {
      getCreateData().then(res => {
        this.initData = res.data
        Storage.localSet('initData', this.initData)
        this.levelList = this.initData.level.sort(function(a, b) {
          return a.currency - b.currency
        })
        this.categoryList = this.initData.category
        this.emotionList = this.initData.emotion
        this.memorialList = this.initData.anniversary
        this.categoryList.forEach(item => {
          if (item.id === this.hallCategoryId) {
            this.hallCategory = item.name
          }
        })
        this.levelList.forEach(item => {
          if (item.id === this.hallLevelId) {
            this.hallLevel = item.name
          }
        })
        this.emotionList.forEach(item => {
          if (item.id === this.emotionId) {
            this.emotion = item.name
          }
        })
        this.memorialList.forEach(item => {
          if (item.id === this.memorialId) {
            this.memorial = item.name
          }
        })
      })
    },
    getTermsOfService() {
      const code = 'Service'
      getSinglepage(code).then(res => {
        this.terms = res.data
      })
    },
    beforeRead(file) {
      const regex = /(.jpg|.jpeg|.png|.bmp)$/
      if (!regex.test(file.type)) {
        Toast.fail('图片格式不支持上传')
        return false
      } else {
        return true
      }
    },
    afterRead(file) {
      file.status = 'uploading'
      file.message = '上传中···'
      uploadImg(file.file).then(res => {
        if (res.success) {
          this.avatar = res.data.url
          this.picture = this.$resUrl(this.avatar)
          this.isAvatarEmpty = false
          file.status = 'done'
          file.message = '上传成功'
        } else {
          file.status = 'failed'
          file.message = '上传失败'
        }
      })
    },
    onOversize() {
      Toast.fail('文件大小不能超过 5M')
    },
    checkAvatar() {
      if (!(this.picture.indexOf('Upload') > -1)) {
        this.avatar = '/Upload/default.jpg'
        // this.picture = this.$resUrl(this.avatar)
        return true
      } else return true
    },
    categorySheet() {
      this.isVisibleCategory = !this.isVisibleCategory
    },
    checkCategory() {
      if (this.hallCategory === '请选择') {
        this.$refs.category.classList.add('hall-item-err')
        this.isCategoryEmpty = true
        return false
      } else return true
    },
    levelSheet() {
      const list = this.$refs.levelList.$el.childNodes[2].childNodes[4].childNodes
      for (let i = 0; i < list.length; i++) {
        list[i].innerHTML = `${this.levelList[i].name}<span class='level-currency'>×${this.levelList[i].currency} 消费币</span>`
      }
      this.isVisibleLevel = !this.isVisibleLevel
    },
    checkLevel() {
      if (this.hallLevel === '请选择') {
        this.$refs.level.classList.add('hall-item-err')
        this.isLevelEmpty = true
        return false
      } else return true
    },
    emotionSheet() {
      this.isVisibleEmotion = !this.isVisibleEmotion
    },
    checkEmotion() {
      if (this.emotion === '请选择') {
        this.$refs.emotion.classList.add('relationship-item-err')
        this.isEmotionEmpty = true
        return false
      } else return true
    },
    memorialSheet() {
      this.isVisibleMemorial = !this.isVisibleMemorial
    },
    checkMemorial() {
      if (this.memorial === '请选择') {
        this.$refs.memorial.classList.add('relationship-item-err')
        this.isMemorialEmpty = true
        return false
      } else return true
    },
    chooseCategory(itemParams) {
      this.hallCategory = itemParams.name
      this.hallCategoryId = itemParams.id
      this.$refs.category.classList.remove('hall-item-err')
      this.isCategoryEmpty = false
    },
    chooseLevel(itemParams) {
      this.hallLevel = itemParams.name
      this.hallLevelId = itemParams.id
      this.$refs.level.classList.remove('hall-item-err')
      this.isLevelEmpty = false
    },
    chooseEmotion(itemParams) {
      this.emotion = itemParams.name
      this.emotionId = itemParams.id
      this.$refs.emotion.classList.remove('relationship-item-err')
      this.isEmotionEmpty = false
    },
    chooseMemorial(itemParams) {
      this.memorial = itemParams.name
      this.memorialId = itemParams.id
      this.$refs.memorial.classList.remove('relationship-item-err')
      this.isMemorialEmpty = false
    },
    switchPicker(param) {
      this[`${param}`] = !this[`${param}`]
    },
    chooseBirth(param) {
      this.birthDay = param[3]
      this.$refs.birthday.classList.remove('main-item-err')
      this.isBirthdayEmpty = false
    },
    checkBirth() {
      if (this.birthDay === '请选择') {
        this.$refs.birthday.classList.add('main-item-err')
        this.isBirthdayEmpty = true
        return false
      } else return true
    },
    chooseDeath(param) {
      this.deathDay = param[3]
      this.$refs.deathday.classList.remove('main-item-err')
      this.isDeathdayEmpty = false
    },
    checkDeath() {
      if (this.deathDay === '请选择') {
        this.$refs.deathday.classList.add('main-item-err')
        this.isDeathdayEmpty = true
        return false
      } else return true
    },
    termsOpen() {
      this.showDialog = true
      // this.$dialog({
      //   noFooter: true,
      //   okBtnTxt: '我已阅读并同意',
      //   textAlign: 'left',
      //   closeOnPopstate: true,
      //   title: this.terms.title,
      //   lockBgScroll: true,
      //   customClass: 'li:{list-style:"normal"}',
      //   content: this.terms.content
      // })
    },
    checkDeadName() {
      if (!this.$isEmpty(this.deadName) && this.$isEmpty(this.hallName)) {
        this.hallName = this.deadName + '纪念馆'
        this.deleHallClass()
      }
      if (!this.deadName) {
        this.$refs.deadName.classList.add('main-item-err')
        this.isDeadNameEmpty = true
        return false
      } else return true
    },
    deleDeadNameClass() {
      this.$refs.deadName.classList.remove('main-item-err')
      this.isDeadNameEmpty = false
    },
    checkHallName() {
      if (!this.hallName) {
        this.$refs.hallName.classList.add('main-item-err')
        this.isHallEmpty = true
        return false
      } else return true
    },
    deleHallClass() {
      this.$refs.hallName.classList.remove('main-item-err')
      this.isHallEmpty = false
    },
    clickDefault() {
      if (
        this.checkCategory() &&
        this.checkLevel() &&
        this.checkHallName() &&
        this.checkDeadName() &&
        this.checkBirth() &&
        this.checkDeath() &&
        this.checkEmotion() &&
        this.checkMemorial() &&
        this.checkAvatar()
      ) {
        if (this.checkbox) {
          // this.$log({
          //   name: '创建纪念馆数据',
          //   hallData: this.hallData
          // })
          this.inHallModelId = this.initData.internal.filter(item => {
            return item.levelList.indexOf(this.hallLevelId) > -1
          })[0].id
          this.outHallModelId = this.initData.external.filter(item => {
            return item.levelList.indexOf(this.hallLevelId) > -1
          })[0].id
          createHall(this.hallData)
            .then(res => {
              if (res.success) {
                Toast.success('创建成功', {
                  duration: 500
                })
                setTimeout(() => {
                  this.$router.push({
                    name: 'HallCreateSuccess',
                    params: {
                      id: res.data
                    }
                  })
                }, 500)
              } else {
                this.inHallModelId = -1
                this.outHallModelId = -1
                if (res.code === 1) {
                  Dialog.confirm({
                    title: '提示',
                    width: '250px',
                    message: res.msg + '，是否充值',
                    confirmButtonColor: '#eea105',
                    closeOnPopstate: true
                  })
                    .then(() => {
                      this.$router.push({
                        name: 'MoneyPay',
                        params: {
                          path: this.$route.path
                        }
                      })
                    })
                    .catch(() => {
                      // on cancel
                    })
                } else if (res.code === 5) {
                  Toast.fail(res.msg)
                }
              }
            })
            .catch(err => {
              this.$error({
                name: '打印错误',
                err: err
              })
            })
        } else {
          Toast.fail('请勾选“我已阅读并同意”')
          return false
        }
      } else {
        Toast.fail('请填写基本信息')
      }
    },
    clickNext() {
      if (
        this.checkCategory() &&
        this.checkLevel() &&
        this.checkHallName() &&
        this.checkDeadName() &&
        this.checkBirth() &&
        this.checkDeath() &&
        this.checkEmotion() &&
        this.checkMemorial() &&
        this.checkAvatar()
      ) {
        if (this.checkbox) {
          this.$log({
            name: '创建纪念馆数据',
            hallData: this.hallData
          })
          Storage.localSet('newHall', this.hallData)
          this.$router.push({
            name: 'createNewHallTwo'
          })
        } else {
          Toast.fail('请勾选“我已阅读并同意”')
          return false
        }
      } else {
        Toast.fail('请填写基本信息')
      }
    }
  },
  beforeRouteEnter: (to, from, next) => {
    if (to.name === 'createNewHall' && (from.path === '/' || from.name === 'manageHallList')) {
      Storage.localRemove('initData')
      Storage.localRemove('newHall')
      Storage.localRemove('CommentTempSelectd')
      next()
    } else if (to.name === 'createNewHall' && (from.name === 'createNewHallTwo' || from.name === 'MoneyPay' || from.name === 'CommentTemp')) {
      next()
    } else {
      next({ path: '/' })
    }
  }
}
</script>

<style lang='scss' scoped>
li {
  position: relative;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  display: flex;
}

li > div:first-child {
  display: inline-block;
  width: 70px;
  height: 50px;
  text-align: justify;
  overflow: hidden;
  vertical-align: top;
  font-weight: bold;
}

li > div:first-child::after {
  content: " ";
  display: inline-block;
  width: 100%;
  height: 0;
}

.steps-section {
  height: 78px;
  margin: 0 15px;
  display: flex;
  justify-content: space-between;
  /*border: 1px solid #000;*/

  .step-item {
    margin: auto 0;
    flex: 1;
    height: 26px;
    color: #efb042;
    background: #f2d59c;
    border-radius: 13px;
    font-size: 13px;
    line-height: 26px;
    text-align: center;
  }

  .active {
    color: #fff;
    background: #eea105;
  }

  .step-next {
    /*border: 1px solid #000;*/
    margin: auto 15px;
    width: 39px;
    height: 18px;
    background: url("~@/assets/images/step-next.png") no-repeat;
    background-size: contain;
  }
}

.hall-section {
  height: 100px;
  background: #fff;

  ::v-deep .nut-actionsheet-item {
    position: relative;
  }

  ::v-deep .level-currency {
    position: absolute;
    right: 50px;
    color: $primary-color-light;
    font-size: 12px;
  }

  .hall-item {
    margin: 0 15px;
    display: flex;
    position: relative;

    .hall-selected {
      padding-left: 25px;
      flex: 1;
    }

    .hall-arrow {
      color: $text-color;
    }

    .hall-tip {
      font-size: 10px;
      line-height: 10px;
      z-index: 0;
      position: absolute;
      top: 37px;
      left: 0px;
      color: $primary-color-bright;
    }
  }

  .hall-item:first-child::after {
    content: "";
    position: absolute;
    left: 0;
    top: auto;
    bottom: 0;
    right: auto;
    height: 1px;
    width: 100%;
    background-color: #f0f0f0;
  }

  .hall-item-err {
    position: relative;
  }

  .hall-item-err:nth-last-child(n + 2)::after {
    content: "";
    position: absolute;
    left: 0;
    top: auto;
    bottom: 0;
    right: auto;
    height: 1px;
    width: 95%;
    background-color: $primary-color-bright;
  }
}

.main-section {
  margin-top: 25px;
  //height: 200px;
  background: #fff;
  display: flex;

  .main-info {
    flex: 1;
    //width: 230px;
    margin-left: 15px;

    .main-item {
      position: relative;

      .main-input {
        flex: 1;

        input {
          width: 85%;
          background-color: rgba(0, 0, 0, 0);
          padding-left: 25px;
          border: none;

          ::placeholder {
            opacity: 1;
            color: #000;
          }
        }
      }

      .main-tip {
        font-size: 10px;
        line-height: 10px;
        z-index: 0;
        position: absolute;
        top: 37px;
        left: 0px;
        color: $primary-color-bright;
      }

      .main-day {
        flex: 1;
        padding-left: 25px;
      }
    }

    .main-item:nth-last-child(n + 2)::after {
      content: "";
      position: absolute;
      left: 0;
      top: auto;
      bottom: 0;
      right: auto;
      height: 1px;
      width: 95%;
      background-color: #f0f0f0;
    }

    .main-item-err {
      position: relative;
    }

    .main-item-err:nth-child(n)::after {
      content: "";
      position: absolute;
      left: 0;
      top: auto;
      bottom: 0;
      right: auto;
      height: 1px;
      width: 95%;
      background-color: $primary-color-bright;
    }
  }

  .main-avatar {
    width: 110px;
    margin-right: 15px;

    .main-ava {
      margin: 30px auto 0;
      background: url("~@/assets/images/avatar-default.png") no-repeat;
      width: 90px;
      height: 90px;
      background-size: contain;
      border-radius: 5px;
    }

    .van-uploader {
      margin: 10px 15px;
      text-align: center;
      font-size: 12px;
      width: 80px;
      height: 24px;
      line-height: 24px;
      background: #d9d2c1;
      border-radius: 3px;

      ::v-deep .van-uploader__input-wrapper {
        margin: 0 auto;
      }
    }

    .main-intro {
      text-align: center;
      font-size: 12px;
    }

    .avatar-tip {
      position: relative;
      top: -3px;
      margin: 0 18px;
      font-size: 10px;
      line-height: 10px;
      text-align: center;
      color: $primary-color-bright;
    }
  }
}

.relationship-section {
  margin-top: 25px;
  height: 100px;
  background: #fff;

  .relationship-item {
    margin: 0 15px;
    display: flex;

    .relationship-selected {
      padding-left: 25px;
      flex: 1;
    }

    .relationship-arrow {
      color: $text-color;
    }

    .relationship-tip {
      font-size: 10px;
      line-height: 10px;
      z-index: 0;
      position: absolute;
      top: 37px;
      left: 0px;
      color: $primary-color-bright;
    }
  }

  .relationship-item:first-child::after {
    content: "";
    position: absolute;
    left: 0;
    top: auto;
    bottom: 0;
    right: auto;
    height: 1px;
    width: 100%;
    background-color: #f0f0f0;
  }

  .relationship-item-err {
    position: relative;
  }

  .relationship-item-err:nth-child(n)::after {
    content: "";
    position: absolute;
    left: 0;
    top: auto;
    bottom: 0;
    right: auto;
    height: 1px;
    width: 95%;
    background-color: $primary-color-bright;
  }
}

.comment-section {
  margin-top: 25px;
  background: #fff;
  padding-bottom: 15px;
  position: relative;
  .comment-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .comment-title {
      margin: 0 15px;
    }
    .comment-temp-entry {
      padding-right: 15px;
      color: #848484;
    }
  }

  .comment-tip {
    font-size: 10px;
    line-height: 10px;
    z-index: 0;
    position: absolute;
    top: 37px;
    left: 15px;
    color: $primary-color-bright;
  }

  .nut-textbox {
    margin: 0 15px;
    border-radius: 10px;

    ::v-deep .txt-area {
      font-size: 14px;
    }

    ::v-deep .txt-area.error {
      border: 1px solid $primary-color-bright;

      span {
        color: $primary-color-bright;
      }
    }

    ::v-deep .comment-left {
      display: inline-block;
      color: #f00;
      font-weight: bold;
    }
  }
}

.service-section {
  margin: 15px;
  height: 48px;
  line-height: 48px;
  display: flex;

  .nut-checkbox {
    font-weight: bold;

    ::v-deep input {
      border-radius: 3px;
    }

    ::v-deep input:checked {
      background-color: $primary-color-bright;
      border-color: $primary-color-bright;
    }
  }

  .service-terms {
    font-size: 14px;
    font-weight: bold;
    color: $primary-color-bright;
  }
}
.service_text{
  padding: 0px 15px;
  font-size: 13px;
  color: #333;
  line-height: 20px;
  max-height: 400px;
  overflow: auto;
}

.next-section {
  padding-bottom: 25px;
  height: 50px;
  margin: 0 15px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: bold;
  text-align: center;

  .next-default {
    width: 56vw;
    height: 40px;
    line-height: 40px;
    color: $primary-color-bright;
    background: #fff;
    border-radius: 5px;
  }

  .next-next {
    width: 30vw;
    height: 40px;
    line-height: 40px;
    color: #fff;
    background: linear-gradient(to right, #f2a612, #f7c827);
    border-radius: 5px;
  }
}

.nut-actionsheet {
  ::v-deep .nut-actionsheet-item-active {
    color: $primary-color;
  }
}

.nut-actionsheet {
  ::v-deep .nut-picker-cancel-btn {
    color: $primary-color;
  }

  ::v-deep .nut-picker-confirm-btn {
    color: $primary-color;
  }
}

.nut-dialog {
  ::v-deep .nut-dialog-content {
    text-align: left;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(12px);
}
</style>
